/**
 * Utility functions for managing workspace ID storage
 * Separated from auth data for cleaner architecture
 */

const WORKSPACE_ID_KEY = 'currentWorkspaceId';

/**
 * Get the currently stored workspace ID
 */
export const getStoredWorkspaceId = (): string | null => {
  try {
    return localStorage.getItem(WORKSPACE_ID_KEY);
  } catch (error) {
    console.error('Failed to get stored workspace ID:', error);
    return null;
  }
};

/**
 * Store a workspace ID and optionally invalidate workspace-related queries
 */
export const setStoredWorkspaceId = (workspaceId: string): void => {
  try {
    localStorage.setItem(WORKSPACE_ID_KEY, workspaceId);
  } catch (error) {
    console.error('Failed to store workspace ID:', error);
  }
};

/**
 * Clear the stored workspace ID
 */
export const clearStoredWorkspaceId = (): void => {
  try {
    localStorage.removeItem(WORKSPACE_ID_KEY);
    console.log('✅ Workspace ID cleared');
  } catch (error) {
    console.error('Failed to clear workspace ID:', error);
  }
};
